import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../../../static/constants'

interface IConversationGuideProps {
  guide: any
  isSelected: boolean
  selectGuide: (guide: any) => void
  isAssigned: boolean
}

const ConversationGuide: React.FC<IConversationGuideProps> = ({
  guide,
  selectGuide,
  isSelected,
  isAssigned,
}) => {
  const handleClick = async () => {
    selectGuide(guide)
  }
  return (
    <S.SelectConversationGuide isModal={false}>
      <S.GuideBadge selected={isSelected} onClick={handleClick}>
        <div className="profile">
          <img src={guide.avatar_url} />
          <span className="type">Guide</span>
          <span className="userName w40">{guide.username}</span>
        </div>
        {isAssigned && <div className="assigned">Assigned</div>}
      </S.GuideBadge>
    </S.SelectConversationGuide>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.SelectConversationGuide = styled.div<{ isModal?: false }>`
  width: calc(30% - 25px);
  min-width: 220px;
  max-width: 380px;
  margin-bottom: ${({ isModal }) => (isModal ? '36px' : '26px')};
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    margin: 0 0 16px;
    width: 100%;
  }
`

S.GuideBadge = styled.div<{ selected?: false }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 8px;
  border-radius: 12px;
  background-color: ${({ selected }) =>
    selected ? constants.COLORS.secondary : constants.COLORS.divider};
  color: ${({ selected }) =>
    selected ? `${constants.COLORS.white}` : `${constants.COLORS.black}`};
  width: 100%;

  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    width: 95%;
  }
  .w65 {
    max-width: 65%;
  }
  .w40 {
    max-width: 40%;
  }
  .profile {
    display: inline-flex;
    align-items: center;
    img {
      object-fit: cover;
      width: 24px;
      min-width: 24px;
      height: 24px;
      border-radius: 12px;
      margin-right: 8px;
    }
    .userName {
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 8px;
    }

    .type {
      border-radius: 12px;
      color: ${constants.COLORS.white};
      padding: 2px 12px;
      background-color: ${constants.COLORS.primary};
      margin-right: 8px;
    }
  }
  .assigned {
    position: absolute;
    top: -20px;
    right: -10px;
    color: ${constants.COLORS.white};
    padding: 2px 12px;
    border-radius: 4px;
    background-color: ${constants.COLORS.caution};
  }
`

export default ConversationGuide
